module.exports = __webpack_public_path__ + "img/flow-num-4.645b7b84.svg";